/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { forwardRef } from 'react';

import EllipsisText from '@components/common/EllipsisText/EllipsisText';

import CreateInquiryFieldLabel from './CreateInquiryFieldLabel';
import { InquiryFileItemsContainerStyled, InquiryFileItemStyled } from './styled/CreateInquiryFileAttributeStyled';

interface ICreateInquiryFileItemsContainerProps {
    files: File[];
    name: string;
    rejected?: boolean;
}

const CreateInquiryFileErrorItemsContainer = forwardRef<HTMLDivElement | null, ICreateInquiryFileItemsContainerProps>(
    ({ files, name, rejected }, ref) => {
        return (
            <InquiryFileItemsContainerStyled className={rejected ? 'rejected' : ''} ref={ref}>
                <CreateInquiryFieldLabel name={name} />
                {files.map((el) => (
                    <InquiryFileItemStyled key={el.name}>
                        <EllipsisText>{el.name}</EllipsisText>
                    </InquiryFileItemStyled>
                ))}
            </InquiryFileItemsContainerStyled>
        );
    },
);

export default CreateInquiryFileErrorItemsContainer;
